import axios from '@/axios';

const RESOURCE_NAME = '/admin/error-reports';

export default {
    getReports(pageParams, filters) {
        return axios.post(`${RESOURCE_NAME}/get-reports`, {...pageParams, filters})
    },

    saveStatus(id, status) {
        return axios.post(`${RESOURCE_NAME}/save-status?id=${id}`, { status });
    },

    sendEmail(id, data) {
        return axios.post(`${RESOURCE_NAME}/send-email?id=${id}`, data);
    },
}
